
<template>
  <swiper
    class="clickable"
    :modules="modules"
    :slides-per-view="1.2"
    :space-between="12"
    :loop="true"
    :breakpoints = breakpoints
    :navigation = "{ nextEl:'.businesslist__controll'}"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <a :href="item.link">
        <figure>
          <img :src="item.pic" :alt="item.dt">
        </figure>
        <h3 v-html="item.ttl"></h3>
        <p>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M160-280v-40h190v40H160Zm0-180v-40h414.62v40H160Zm0-180v-40h640v40H160Z"/></svg>
          <span v-html="item.cate"></span>
        </p>
        <svg class="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M460-300h40v-160h160v-40H500v-160h-40v160H300v40h160v160Zm20.13 180q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Z"/></svg>
      </a>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  figure{
    position: relative;
    border: rgba(module.$white,.12) 1px solid;
    overflow: hidden;
    border-radius: 1rem 1rem 0 0;
    transition: border 320ms module.$ease;
    &:before,
    &:after{
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: module.$black;
      opacity: 0;
      transition: all 320ms module.$ease;
      z-index: 2;
    }
    &:after{
      content: 'MORE';
      width: auto;
      height: auto;
      top: 60%;
      left: 50%;
      padding: .4rem 3.2rem;
      background: module.$base;
      box-shadow: 0 .24rem 2.4rem rgba(module.$base,.8);
      color: module.$white;
      border-radius: 999rem;
      transform: translate(-50%, -50%);
    }
  }
}
a{
  display: block;
  color: module.$normal;
  background: module.$white;
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
  &:hover{
    figure{
      border: rgba(module.$white,.24) 1px solid;
      &:before{
        opacity: .8;
      }
      &:after{
        top: 50%;
        opacity: 1;
      }
      img{
        transform: scale(1.1);
      }
    }
  }
}
img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 320ms module.$ease;
}
h3{
  font-weight: 700;
  margin: 1.2rem 1.6rem;
  line-height: 1.6;
  position: relative;
}
p{
  padding: 1rem 1.6rem;
  padding-right: 4rem;
  border-top: module.$border 1px solid;
  display: grid;
  grid-template-columns: 1.6rem auto;
  gap: 1rem;
  > *{
    align-self: center;
  }
  svg{
    fill: module.$normal;
  }
}
.plus{
  width: 2rem;
  position: absolute;
  right: 1.5rem;
  bottom: 1rem;
  fill: module.$normal;
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
      const breakpoints = {
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 24,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    }

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      breakpoints,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
